RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.ErrorAlert = Marionette.ItemView.extend({
        template: '#shellErrorAlertTemplate',

        ui: {
            expandLink: '.x-expand',
            details: '.x-details'
        },

        events: {
            'click @ui.expandLink': 'expand'
        },

        templateHelpers: function () {
            const me = this;
            const defaults = {
                description: '',
                details: ''
            };

            return _.extend(defaults, me.model.toJSON());
        },

        expand: function (e) {
            const me = this;
            e.preventDefault();
            me.ui.details.toggleClass('hide');
        },

        parseJSON: function (text) {
            try {
                return $.parseJSON(text);
            } catch (e) {
                return null;
            }
        },

        parseRESTError: function (error) {
            const me = this;
            me.model.set({
                description: error.displayString
            });
        },

        parseUnknown: function (error) {
            const me = this;
            me.model.set({
                details: error
            });
        },

        parseError: function () {
            const me = this;
            const response = me.model.get('responseText');
            const json = me.parseJSON(response);

            if (json && json.RESTerror) {
                me.parseRESTError(json.RESTerror);
            } else {
                me.parseUnknown(response);
            }
        },

        initialize: function () {
            const me = this;
            me.parseError();
        }
    });
});
